import Translations from "../lang/en/pages.json";

/** Replace $variable and {variable} placeholders in backend-supplied strings. */
export function interpolate(
  template: string | undefined | null,
  vars: Record<string, string | number>
): string {
  if (!template) return "";
  return template.replace(/\$(\w+)|\{(\w+)\}/g, (match, dollar, brace) => {
    const key = dollar ?? brace;
    return key in vars ? String(vars[key]) : match;
  });
}

const T = (Translations as any).unified_upload ?? {};

export const dropZone = {
  title: T.drop_zone.title as string,
  subtitle: T.drop_zone.subtitle as string,
  browse: T.drop_zone.browse as string,
};

export const filters = {
  all: T.filters.all as string,
  errors: T.filters.errors as string,
  pending: T.filters.pending as string,
  accepted: T.filters.accepted as string,
};

export const countLabels = {
  accepted: T.counts.accepted as string,
  errors: T.counts.errors as string,
  pending: T.counts.pending as string,
  total: T.counts.total as string,
};

export const sessionFailed = {
  resubmit: T.session_failed.resubmit as string,
  resubmitDisabledTooltip: T.session_failed.resubmit_disabled_tooltip as string,
};

export const row = {
  uploading: T.row.uploading as string,
  validating: T.row.validating as string,
  extractingZip: T.row.extracting_zip as string,
  copying: T.row.copying as string,
  processing: T.row.processing as string,
  existingBadge: T.row.existing_badge as string,
};

export const card = {
  whatToDoPrefix: T.card.what_to_do_prefix as string,
  retry: T.card.retry as string,
  allowedExtensions: (list: string) =>
    (T.card.allowed_extensions as string).replace("{list}", list),
};

export const emptyFilter = T.empty_filter as string;

export function readyToUpload(count: number): string {
  if (count === 1) return T.intake.ready_one as string;
  return (T.intake.ready_other as string).replace("{count}", String(count));
}

export function addMore(): string {
  return T.intake.add_more as string;
}

export function pendingCount(n: number): string {
  return `${n} ${countLabels.pending}`;
}

export function unsupportedLabel(count: number): string {
  if (count === 1) return T.card.unsupported_label_one as string;
  return (T.card.unsupported_label_other as string).replace("{count}", String(count));
}

export function completionMessage(accepted: number, total: number): string {
  if (accepted === total) {
    if (total === 1) return T.complete.all_accepted_one as string;
    return (T.complete.all_accepted_other as string).replace("{total}", String(total));
  }
  return (T.complete.partial as string)
    .replace("{accepted}", String(accepted))
    .replace("{total}", String(total));
}
